import { useState } from 'react';
import AutoForm from './autoForm';
import ManualForm from './manualForm';
import formError from 'components/Shared/Form/formError.scss';
import { rm } from 'utils';
import connect from 'components/Shared/connect';
import Icon from 'components/Shared/Icon';
import { checkoutForm } from 'views/CheckoutPage/selector';
import { CheckoutFormData } from 'models/CheckoutFormData';

interface OwnProps {
  reset: (quickStart: boolean) => void;
}
interface MergedProps extends OwnProps {
  hasRotDeduction: boolean;
  quickStart: boolean;
}

const _ContactInfoCompany = ({ reset, hasRotDeduction, quickStart }: MergedProps) => {
  const [useQuickStart, setQuickStart] = useState(quickStart);
  const toggleQuickStart = () => {
    const newQuickStartValue = !useQuickStart;
    setQuickStart(newQuickStartValue);
    reset(newQuickStartValue);
  };
  const resetForm = () => {
    reset(useQuickStart);
  };

  return (
    <div>
      {hasRotDeduction && (
        <div className={formError.rotWarning}>
          <Icon icon="icon-warning" inline />
          <span>{rm('checkout_company_rot_error')}</span>
        </div>
      )}

      {useQuickStart ? (
        <AutoForm resetForm={resetForm} toggleQuickStart={toggleQuickStart} />
      ) : (
        <ManualForm toggleQuickStart={toggleQuickStart} />
      )}
    </div>
  );
};

type FormProps = Pick<CheckoutFormData, 'address' | 'cache' | 'quickStart'>;
interface StateProps {
  form: FormProps;
}
export const ContactInfoCompany = connect<MergedProps, OwnProps, StateProps>(
  state => ({
    form: checkoutForm(state, 'address', 'cache', 'quickStart') as FormProps,
    hasRotDeduction: state.cart.hasRotDeduction
  }),
  undefined,
  ({ form, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    quickStart: form.quickStart
  })
)(_ContactInfoCompany);
